import { render, staticRenderFns } from "./regionAddManager.vue?vue&type=template&id=27adc489&scoped=true"
import script from "./regionAddManager.vue?vue&type=script&lang=js"
export * from "./regionAddManager.vue?vue&type=script&lang=js"
import style1 from "./regionAddManager.vue?vue&type=style&index=1&id=27adc489&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27adc489",
  null
  
)

export default component.exports